import * as React from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { useLocation } from 'react-router-dom';

import { MainPage, ArticleList, NewsList, BlogList, QuestionList, SearchList, DocumentListing } from '../Listings';
import { PageReload } from '../../components/PageReload';
import { useContext } from 'react';
import { ApplicationContext, prepareQSParam } from '../../utils';
import { withRatingAccess } from './utils/withRatingAccess';
import { RatingAccessDeniedPageContainer } from '../AccessDeniedPages';
import { PostCardContainer } from '../PostCard';
import { AddBlogPageContainer } from '../AddBlogPage';
import { AddQuestionPageContainer } from '../AddQuestionPage';
import { PostPreviewCardContainer } from '../PostPreviewCard';
import { RealtorRatingPageContainer } from '../RealtorRatingPage';

export const RoutesNew = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const {
    custom: {
      isNewDesignForPostPreviewCardEnabled,
      isNewDesignForAddQuestionPageEnabled,
      isNewDesignForAddBlogPageEnabled,
      isNewDesignForUnsubscribeEmailPageEnabled,
    },
  } = useContext(ApplicationContext);
  const qsSearch = prepareQSParam(searchParams.get('search'));
  const qsTag = prepareQSParam(searchParams.get('tag'));
  const qsSlugId = prepareQSParam(searchParams.get('slug-id'));

  return (
    <Switch>
      <Route path={`/magazine/`} strict exact component={qsTag || qsSearch ? SearchList : MainPage} />
      {/* Переадресует оставшееся на корневую группу */}
      <Redirect from="/magazine/" to="/magazine/" />

      <Route path={`/magazine-biblioteka-dokumentov/`} strict exact component={DocumentListing} />

      <Route path={`/magazine-:path/`} strict exact component={ArticleList} />
      {/* Переадресует оставшееся на корневую группу */}
      <Redirect from="/magazine-:path/" to="/magazine/" />

      <Route
        path={`/stati/`}
        strict
        exact
        render={() => {
          return qsTag || qsSearch ? <SearchList /> : <Redirect from="/stati/" to="/magazine/" />;
        }}
      />

      <Redirect from="/stati/" to="/magazine/" />

      <Route path={`/novosti/:path/`} strict exact component={NewsList} />
      {/* Переадресует оставшееся на корневую группу */}
      <Redirect from="/novosti/:path/" to="/novosti/" />

      <Route path={`/novosti/`} strict exact component={qsTag || qsSearch ? SearchList : NewsList} />
      {/* Переадресует оставшееся на корневую группу */}
      <Redirect from="/novosti/" to="/novosti/" />

      <Route
        path={`/blogs-specialist/`}
        strict
        exact
        component={withRatingAccess(BlogList, RatingAccessDeniedPageContainer)}
      />

      <Route path={`/blogs-tendentsiy-rynka/`} strict exact component={BlogList} />

      <Route path={`/blogs/`} strict exact component={qsTag || qsSearch ? SearchList : BlogList} />
      {/* Переадресует оставшееся на корневую группу */}
      <Redirect from="/blogs(-specialist|-tendentsiy-rynka)?/" to="/blogs/" />

      {/* Поддерживает только "/moi-blog/" */}
      <Route path={`/moi-blog/`} strict exact component={BlogList} />

      {/* Переадресует оставшееся на корневую группу */}
      <Redirect from="/moi-blog/" to="/blogs/" />

      <Route
        path={`/forum-rieltorov-specialist/`}
        strict
        exact
        component={withRatingAccess(QuestionList, RatingAccessDeniedPageContainer)}
      />

      <Route
        path={`/forum-rieltorov(-tendentsiy-rynka|-gorodskaya-nedvizhimost|-kommercheskaya-nedvizhimost|-zagorodnaya-nedvizhimost|-zarubezhnaya-nedvizhimost|-ipoteka)/`}
        strict
        exact
        component={QuestionList}
      />

      <Route path={`/forum-rieltorov/`} strict exact component={qsTag || qsSearch ? SearchList : QuestionList} />

      {/* Переадресует оставшееся на корневую группу */}
      <Redirect
        from="/forum-rieltorov(-specialist|-tendentsiy-rynka|-gorodskaya-nedvizhimost|-kommercheskaya-nedvizhimost|-zagorodnaya-nedvizhimost|-zarubezhnaya-nedvizhimost|-ipoteka)?/"
        to="/forum-rieltorov/"
      />

      <Route path={`/forum-rieltorov-:id/`} component={PostCardContainer} />

      <Route path={`/novosti-:id/`} component={PostCardContainer} />

      <Route path={`/blogs-:id/`} component={PostCardContainer} />

      <Route path={`/stati-:id/`} component={PostCardContainer} />

      <Route path={`/add-blog/:path/`} strict exact component={AddBlogPageContainer}>
        {!isNewDesignForAddBlogPageEnabled && <PageReload />}
      </Route>
      {/* Переадресует оставшееся на корневую группу */}
      <Redirect from="/add-blog/:path/" to="/add-blog/" />

      <Route
        path={`/add-blog/`}
        strict
        exact
        render={() => {
          if (!isNewDesignForAddBlogPageEnabled) {
            return <PageReload />;
          }

          return qsSlugId ? <Redirect from="/add-blog/" to={`/add-blog/${qsSlugId}/`} /> : <AddBlogPageContainer />;
        }}
      />
      {/* Переадресует оставшееся на корневую группу */}
      <Redirect from="/add-blog/" to="/add-blog/" />

      <Route path={`/add-vopros/:path/`} strict exact component={AddQuestionPageContainer}>
        {!isNewDesignForAddQuestionPageEnabled && <PageReload />}
      </Route>
      {/* Переадресует оставшееся на корневую группу */}
      <Redirect from="/add-vopros/:path/" to="/add-vopros/" />

      <Route
        path={`/add-vopros/`}
        strict
        exact
        render={() => {
          if (!isNewDesignForAddQuestionPageEnabled) {
            return <PageReload />;
          }

          return qsSlugId ? (
            <Redirect from="/add-vopros/" to={`/add-vopros/${qsSlugId}/`} />
          ) : (
            <AddQuestionPageContainer />
          );
        }}
      />
      {/* Переадресует оставшееся на корневую группу */}
      <Redirect from="/add-vopros/" to="/add-vopros/" />

      <Route path={`/(content-)?preview/`} component={PostPreviewCardContainer}>
        {!isNewDesignForPostPreviewCardEnabled && <PageReload />}
      </Route>

      <Route
        path={`/unsubscribe-email/`}
        render={() => {
          if (!isNewDesignForUnsubscribeEmailPageEnabled) {
            return <PageReload />;
          }

          return <Redirect from="/unsubscribe-email/" to="/magazine/" />;
        }}
      />

      <Route path={`/reyting-rieltorov/`} component={RealtorRatingPageContainer} />

      {/* Редирект на Главную путей вида "///path" */}
      <Redirect from="//*" to="/magazine/" />
    </Switch>
  );
};
